import React, { useState, useEffect } from "react";
import { Outlet, useParams, useNavigate } from "react-router-dom";
import { Button, Empty,Card } from "antd";


import "./usersubscription.scss";

import superUseStatsStore from "../../store/superuser.store";
import SuperUserPlanTableSelectable from "../SuperUserPlanTableSelecable";
import SuperAdminPriceTableSelectable from "../SuperAdminPriceTableSelectable";
import { SUBSCRIPTION_DETAILS_TABLE_COLUMNS_WIDTH } from "../../helper/tablewidthcontants";


const summaryListTable = [
    "Select",
    "Sr. No.",         
    "Company Name",   
    "Super Admin Name",
    "Super Admin Phone",     
    "Super Admin Email",
    "Onboarding Date",
    "Plan Name",
    "Onboarding Status",
    "Document Verification", 
    "Trial Status",  
    "Subscription Status", 
    "Payment Status",     
    "Address",
    "Pin",
    "City",          
    "Country",
];


const planListTable = [
    "Select",
    "Sr. No.",
    "Plan Name",  
    "Product",
    "Trial Period",
    "No of Users",
    "No of Resumes",
    "No of JDs/Post",
    "Vendor Connect",
    "Q Plan Price",
    "HY Plan Price",
    "Y Plan Price", 
    "Additional User Price" ,  
    "Additional Resumes Price",    
];

const mySubscriptionTable = [
    "Sr. No.",
    "Type", 
    "Plan Name", 
    "Status",
    "Duration",
    "Start Date",
    "End Date"   
];
const historySubscriptionTable = [
    "Select",
    "Sr. No.",
    "Plan Name", 
    "Type", 
    "Status",
    "Duration",
    "Start Date",
    "End Date",
    "Due Amount",
    "Payment Status",
    "Payment Date",
    "Bank Name",
    "Reference Number"    
];
const myplanTable = [
    "Select",
    "Sr. No.",
    "Plan Name",  
    "Product",
    "No of Users",
    "No of Resumes",
    "No of Jb Posts",
    "Vendor Connect",    
];

export default function UserSubscription() {
    const [currentView, setCurrentView] = useState("mysubscriptions");
    const [selectedResumeID, setResumeID] = useState("");
    const navigate = useNavigate();
    const { value } = useParams();
    const moment = require('moment');
    const { getSuperAdminInfo,superAdminInfo} = superUseStatsStore();
    useEffect(() => {
       getSuperAdminInfo("All");
    }, []);

    const statsData = superAdminInfo?.stats?.map((comp, idx) => {
        return {
            select:"",
            id: idx+1,
            name: comp?.companyname,
            jds:  comp?.totaljds,
            resumes: comp?.totalresumes,
            users: comp?.totalusers,
            vendors:  comp?.totalvendors,
            customers: comp?.totalcustomers,
        };
    });   

    const getSubType =(status)=>{
        const version_array = status.split('_')
        if(version_array[0] === "trial"){return "TRIAL"}
        if(version_array[0] === "subscription"){return "SUBSCRIPTION"}     
    }

    const getPlanID =(idx)=>{
        if(superAdminInfo?.subscriptionstats === null){
            return superAdminInfo?.freestats?.[idx].shistory?.[0].subid
        }   
        if(superAdminInfo?.freestats === null){
            return superAdminInfo?.subscriptionstats?.[idx].shistory?.[0].subid
        }  
    }
    const getEndDate =(idx)=>{
        if(superAdminInfo?.subscriptionstats === null){
            return superAdminInfo?.freestats?.[idx].shistory?.[0].enddate
        }   
        if(superAdminInfo?.freestats === null){
            return superAdminInfo?.subscriptionstats?.[idx].shistory?.[0].enddate
        }  
    }
    const getStartDate =(idx)=>{
        if(superAdminInfo?.subscriptionstats === null){
            return superAdminInfo?.freestats?.[idx].shistory?.[0].startdate
        }   
        if(superAdminInfo?.freestats === null){
            return superAdminInfo?.subscriptionstats?.[idx].shistory?.[0].startdate
        }  
    }
    const extraData = superAdminInfo?.adminstats?.map((comp, idx) => {
        var subID = getPlanID(idx)
        return {
            qhoid: comp?.companyid,
            subID: subID,
            startdatets:getStartDate(idx),
            enddatets:getEndDate(idx),        
        };
    });  

    
    const convertDateFromTStoDate = (ts) =>{
        if(ts !=""){
            var date = new Date(ts * 1000);
            return moment(date).format('YYYY.MM.DD');

        }else{
            return ""
        }
        
    }

    const planListData = superAdminInfo?.planlist?.map((plan, idx) => {
        return {
            select:"",
            id: idx+1,
            name: plan.planname,
            product: plan.product==""?"QHRFlow":plan.product,
            trialperiod: plan.trialperiod,
            maxusers: plan.maxusers,
            maxresumes: plan.maxresumes,
            maxjds: plan.maxjds,
            vendorconnect: plan.vendorconnect,
            quarterly: plan.quarterly,            
            hyearly: plan.hyearly,
            yearly: plan.yearly,
            addonuseramt: plan.addonuseramt,
            addonresumeamt: plan.addonresumeamt,           
        };
    });    

    const mySubscriptionListData = superAdminInfo?.subscriptionstats?.map((stats, idx) => {
        var stype = getSubType(stats?.shistory?.[0].status)
        var sduration = stype==="TRIAL"?stats?.shistory?.[0].trialperiod :stats?.shistory?.[0].duration + " Months"
        return {
            id:idx+1,
            type:stype,
            planname: stats?.shistory?.[0].planname,
            substatus: stats?.shistory?.[0].status,
            duration: sduration,
            startdate: convertDateFromTStoDate(stats?.shistory?.[0].startdate),
            enddate: convertDateFromTStoDate(stats?.shistory?.[0].enddate)
        };
    });  

    const historySubscriptionListData = superAdminInfo?.subscriptionstats?.map((stats, idx) => {
        var stype = getSubType(stats?.shistory?.[0].status)
        var sduration = stype==="TRIAL"?stats?.shistory?.[0].trialperiod :stats?.shistory?.[0].duration + " Months"
        return {
            select:"",
            id:idx+1,
            planname: stats?.shistory?.[0].planname,
            type:stype,
            substatus: stats?.shistory?.[0].status,
            duration: sduration,
            startdate: convertDateFromTStoDate(stats?.shistory?.[0].startdate),
            enddate: convertDateFromTStoDate(stats?.shistory?.[0].enddate),
            planamount:stats?.shistory?.[0].paymentamount,
            paymentstatus: stats?.shistory?.[0].paymentstatus,
            paymentdate: stats?.shistory?.[0].paymentdate,
            bankname:"",
            referencenumber: stats?.shistory?.[0].paymentmethod,
        };
    });   

    const getSubDisplayStatus =(status)=>{
        if(status === "trial_none"){return "-"}
        if(status === "trial_inactive"){return "INACTIVE"}
        if(status === "trial_active"){return "ACTIVE"}
        if(status === "trial_expired"){return "EXPIRED"}   
        if(status === "trial_stop"){return "STOP"}
        if(status === "trial_activation_in_progress"){return "ACTIVATION IN PROGRESS"}    
        if(status === "subscription_none"){return "-"}
        if(status === "subscription_inactive"){return "INACTIVE"}
        if(status === "subscription_new_req"){return "NEW REQ "}
        if(status === "subscription_configured"){return "CONFIGURED"}
        if(status === "subscription_active"){return "ACTIVE"}
        if(status === "subscription_expired"){return "EXPIRED"}
        if(status === "subscription_stopped"){return "STOPPED"} 
        if(status === "subscription_aborted"){return "ABORTED"} 
        if(status === "subscription_activation_in_progress"){return "ACTIVATION IN PROGRESS"}  

    }

    return (

        <div className="superadmin-summary-wrapper">
            {currentView !== "profile" && (
                <>
                    <div className="section-header">
                        <h3 className="title">QUALLYHIRE Subscription Details</h3>
                    </div>
                    <div className="jd-summary-buttons-wrapper">                        
                        <Button className="jd-summary-btn"
                            onClick={() => setCurrentView("mysubscription")}>
                            Product Subscription
                        </Button>                                                                             
                    </div>
                </>
            )}
            {superAdminInfo != null? (
                <div className="jd-summary-wrapper">
                    {
                    currentView === "plans" ? (
                           <SuperUserPlanTableSelectable
                                isClickable
                                titleList={planListTable}
                                isEditField = {true}
                                data={planListData}
                                setCurrentView={setCurrentView}
                                currentView = {currentView}                                
                          />                                                                                                                      
                    ): (
                        <div className="superadmin-subs-wrapper ">
                          <div className="superadmin-subs-cards-wrapper">
                            <Card title="Subscription Status" variant="borderless" style={{ backgroundColor: "#edbb99" }}>
                                {getSubDisplayStatus(superAdminInfo?.subscriptionstats?.[0]?.shistory?.[0].status)}
                            </Card>
                            <Card title="Plan Name" variant="borderless" style={{ backgroundColor: "#f8c471" }}>
                                {superAdminInfo?.subscriptionstats?.[0]?.shistory?.[0].planname}
                            </Card>
                            <Card title="Subscription Mode" variant="borderless" style={{ backgroundColor: "#fad7a0" }}>
                                {getSubType(superAdminInfo?.subscriptionstats?.[0]?.shistory?.[0].status)}
                            </Card>
                          </div>

                          <div className="superadmin-subs-heading" > Subscription Details</div>
                          <div className="superadmin-subs-history"> 
                                <SuperAdminPriceTableSelectable
                                        titleList={mySubscriptionTable}
                                        data={mySubscriptionListData}
                                        setCurrentView={setCurrentView}
                                        currentView = {currentView}
                                        isEditField
                                        columnWidth={SUBSCRIPTION_DETAILS_TABLE_COLUMNS_WIDTH}
                                        
                                />
                          </div>                         
                        </div>                                                                                             
                    )}
                    
                </div>
            ) : (
                <Empty style={{ margin: "60px" }} >
                    <h4>User Dash Board</h4>
                </Empty>
            )}         
        </div>
    );
}
